import Util from "./Util";
import PagedDataWrapper from "./PagedDataWrapper";
import DataWrapper from "./DataWrapper";

export class WrapperFactory{
    static fromResponse(response){
        if(Util.isPaginated(response))
            return new PagedDataWrapper(response)
        else{
            return new DataWrapper(response)
        }
    }
}